import React from "react";

export const SectionSnap = ({ children }) => {
  return <div className="section_snap">{children}</div>;
};
